import { useEffect, useState } from 'react';
import { runAuthSessionBootstrap } from '@/lib/authSessionBootstrap';

interface SessionReadyGateProps {
  children: React.ReactNode;
}

/**
 * Дожидается гидрации auth из sessionStorage и при необходимости — POST /auth/refresh
 * по httpOnly cookie, чтобы защищённые маршруты не редиректили на /login после новой вкладки.
 */
export function SessionReadyGate({ children }: SessionReadyGateProps) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    void runAuthSessionBootstrap().finally(() => {
      if (!cancelled) {
        setReady(true);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!ready) {
    return (
      <div
        className="flex min-h-screen items-center justify-center bg-background text-muted-foreground"
        aria-busy="true"
        aria-live="polite"
      >
        Загрузка…
      </div>
    );
  }

  return <>{children}</>;
}
